import {
    SET_AGENDA_SESSION,
    SET_AGENDA_SESSION_SPEAKERS,
    RESET_SESSION_DATA,
    SET_AGENDA_SESSION_RATE,
    SET_VIRTUAL_SESSION_DETAILS,
    SET_CURRENT_RECORD_URL,
    SET_AGENDA_SESSION_ERROR,
    SET_SESSION_UPCOMING_SESSIONS,
} from '../constants/ActionTypes';

import * as ApiUtils from '../views/reactViews/ApiUtil';
import {
    fetchAgendaSettings,
    fetchMarkers,
    changeSessionRegistrationStatus,
    registeredSessionIdsFetched
} from './AgendaActions';

import { checkIfHasError } from '../views/reactViews/ApiUtil';

import {
    shouldFetchAgendaSettingsSelector,
    shouldFetchMarkersSelector,
    agendaSessionSelector,
    agendaSpeakersByIds,
    shouldFetchRegistrationEnabledSelector
} from '../selectors/AgendaSelectors';

import { shouldFetchRegisteredSessionsSelector } from '../selectors/MeSelectors';
import {
    addSPSessionToGlobalContext,
    startSPSessionTrack
} from '../utils/SnowplowUtils';
import { fetchSessionsFromApi } from './helpers';

const setAgendaSessionAction = session => ({
    type: SET_AGENDA_SESSION,
    payload: session
});

const setAgendaSessionSpeakersAction = speakers => ({
    type: SET_AGENDA_SESSION_SPEAKERS,
    payload: speakers
});

const setSessionUpcomingSessionsAction = sessions => ({
    type: SET_SESSION_UPCOMING_SESSIONS,
    payload: sessions
});

const resetSessionDataAction = () => ({
    type: RESET_SESSION_DATA
});

const setAgendaSessionRateAction = (payload) => ({
    type: SET_AGENDA_SESSION_RATE,
    payload
});

const setSessionNotFoundErrorAction = payload => ({
    type: SET_AGENDA_SESSION_ERROR,
    payload,
});

export const fetchSessionData = (eventId, sessionId, isAuthenticated, isPreviewSession = false) => async(dispatch, getState) => {
    try {
        dispatch(resetSessionDataAction());
        const state = getState();
        if (shouldFetchAgendaSettingsSelector(state)) {
            fetchAgendaSettings(eventId)(dispatch, getState);
        }
        fetchMarkers()(dispatch, getState);

        const session = agendaSessionSelector(state, { eventId, sessionId }) ||
            await ApiUtils.getSession({ eventId, sessionId });
        if (!isPreviewSession) {
            addSPSessionToGlobalContext(session, state.eventReducer.event['time-zone-id']);
            startSPSessionTrack(isAuthenticated);
        }
        if (isAuthenticated) {
            const rateResponse = await ApiUtils.getRate({eventId, sessionId});
            rateResponse && dispatch(setAgendaSessionRateAction(rateResponse));
        }

        const verifiedSession = checkIfHasError(session);

        if (shouldFetchRegistrationEnabledSelector(state)) {
            const isSessionRegistrationEnabled = await ApiUtils.getRegistrationEnabled({eventId});
            dispatch(changeSessionRegistrationStatus(isSessionRegistrationEnabled));
        }

        if (shouldFetchRegisteredSessionsSelector(state)) {
            const registeredSessionIds = await ApiUtils.getRegisteredSessionIds({eventId});
            dispatch(registeredSessionIdsFetched(registeredSessionIds));
        }

        dispatch(setAgendaSessionAction(verifiedSession));

        const { speakers: sessionSpeakers } = verifiedSession;
        if (sessionSpeakers) {
            const ids = sessionSpeakers.reduce((ids, speaker) => [...ids, speaker.speakerId], []);
            const speakers = agendaSpeakersByIds(state, { ids }) ||
                await ApiUtils.getSpeakers({ eventId, query: { ids } });
            const verifiedSpeakers = checkIfHasError(speakers);
            dispatch(setAgendaSessionSpeakersAction(verifiedSpeakers));
        }
    } catch (err) {
        if (err.errorCode === 'session_not_found') {
            dispatch(setSessionNotFoundErrorAction(err));
        }
    }
};

export const fetchUpcomingSessions = (session, eventId, count) => async(dispatch, getState) => {
    const state = getState();
    const query = {
        count,
        startTimestamp: session.endTime,
        sort: 'date'
    };
    try {
        const sessions = await fetchSessionsFromApi(state)({
            eventId,
            query
        });
        dispatch(setSessionUpcomingSessionsAction(sessions));
    } catch {
        dispatch(setSessionUpcomingSessionsAction([]));
    }
};

export const sendRate = (options) => async(dispatch) => {
    try {
        const response = await ApiUtils.sendRate(options);
        dispatch(setAgendaSessionRateAction(response));

    } catch (err) {
        throw err;
    }
};

export const setVirtualSessionDetails = (sessionId, virtualDetails) => (
    {
        type: SET_VIRTUAL_SESSION_DETAILS,
        payload: { sessionId, virtualDetails }
    }
);

export const setRecordUrl = (url) => ({
    type: SET_CURRENT_RECORD_URL,
    payload: { url }
});
